import { body as baseBody } from './sets/base';

import { body as mysteryBody } from './sets/mystery';
import { body as specialBody } from './sets/special';
import { body as armoireBody } from './sets/armoire';

const body = {
  base: baseBody,
  mystery: mysteryBody,
  special: specialBody,
  armoire: armoireBody,
};

export default body;
